import React, { useState, useEffect, RefObject } from 'react'
import { range } from '../functions/range';

type useGridLineProps<N extends number> = {
    objectRef: RefObject<HTMLElement>
    xNumList: readonly number[] & { length: N}
    yNumList: readonly number[] & { length: N }
    deps?: any[]
}

// xNumListとyNumList の最初は使われない！
export function useGridLineWithStage<T extends number> ( { objectRef, xNumList, yNumList, deps = [] }: useGridLineProps<T>){

    const [ stageNum, setStageNum ] = useState( 0 );
    const [ heightInterval, setHeightInterval ] = useState( 0 );
    const [ widthInterval, setWidthInterval ] = useState( 0 );

    useEffect( () => {
        if ( !objectRef.current ) return
        const height = objectRef.current.getBoundingClientRect().height
        const width = objectRef.current.getBoundingClientRect().width
        setHeightInterval( height / ( yNumList[ stageNum ] + 1 ) )
        setWidthInterval( width / ( xNumList[ stageNum ] + 1 ) )
    }, [ objectRef, stageNum, ...deps ] )

    const incrementStageNum = () => {
        stageNum == xNumList.length - 1 ?
            setStageNum( 0 ) :
            setStageNum( stageNum + 1 )
    }

    const renderXLines = () =>
        <>
            {range( 0, xNumList[ stageNum ] ).map( i =>
                <div
                    style={ {
                        position: "fixed",
                        top: heightInterval * ( i + 1 ),
                        left: 0,
                        right: 0,
                        height: 1,
                        width: "100%",
                        backgroundColor: "rgba(255,255,255,0.3)",
                    } }></div>
            ) }
        </>

    const renderYLines = () =>
        <>
            {range( 0, yNumList[ stageNum ] ).map( i =>
                <div
                    style={ {
                        position: "fixed",
                        top: 0,
                        bottom: 0,
                        left: widthInterval * ( i + 1 ),
                        width: 1,
                        height: "100%",
                        backgroundColor: "rgba(255,255,255,0.3)",
                    } }></div>
            ) }
        </>

    // const GridLines=

    const GridLines =
        <div style={ {
            position: 'fixed',
            inset: 0,
            zIndex: 2,
            pointerEvents: "none"
        } }>
            { renderXLines() }
            { renderYLines() }
        </div>


    return {
        stageNum,
        incrementGridStage: incrementStageNum,
        GridLines: stageNum ? GridLines : null
    }
}
